import "./CheckEmailModal.scss";
import React, { useEffect, useRef } from "react";
import {
  IonButton,
  IonContent,
  IonIcon,
  IonModal,
  IonText,
  isPlatform,
} from "@ionic/react";
import checkEmailIcon from "../../assets/svg/check-email.svg";
import p from "../../../package.json";
import { AppLauncher, AppLauncherOptions } from "@ionic-native/app-launcher";
import moment from "moment";

interface Props {
  isOpen: boolean;
  setIsOpen?: (isOpen: boolean) => void;
}

const CheckEmailModal: React.FC<Props> = React.memo(({ isOpen }) => {
  const modalRef = useRef<any>(null);

  useEffect(() => {
    const mdlRef = modalRef.current;
    return () => {
      if (mdlRef) {
        mdlRef.dismiss();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const launchEmailApp = async () => {
    const options: AppLauncherOptions = {};

    if (isPlatform("ios")) {
      options.uri = "message://";
    } else {
      options.packageName = "com.google.android.gm";
    }

    AppLauncher.launch(options);
  };

  return (
    <IonModal
      isOpen={isOpen}
      className="check-email-modal"
      backdropDismiss={false}
      ref={modalRef}
    >
      <IonContent>
        <div className="check-email-modal-container">
          <div className="check-email-modal-content">
            <IonIcon icon={checkEmailIcon} className="modal-icon" />
            <IonText className="title">Check your email</IonText>
            <p>
              Approval required.
              <br />
              Please check your email for verification
            </p>

            <IonButton
              color="danger"
              expand="full"
              shape="round"
              className="open-email-app-btn"
              onClick={launchEmailApp}
            >
              Open email app
            </IonButton>

            <p className="footer-text">
              © {moment().format("YYYY")} Abaxx Technologies | ver {p.version}
            </p>
          </div>
        </div>
      </IonContent>
    </IonModal>
  );
});

const MemoizedCheckEmailModal: React.FC<Props> = ({ isOpen }) => {
  return <CheckEmailModal isOpen={isOpen} />;
};

export default MemoizedCheckEmailModal;
